
import { defineComponent } from 'vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';

export default defineComponent({
  name: 'PaymentAddedDialog',

  components: {
    CustomButton,
    CustomDialog,
  },

  props: {
    card: { type: Boolean, default: false },
    lastFour: { type: [String, Number], default: '' },
  },
});
